export const PRECONTRACTUAL_INFORMATION_DOCUMENT =
    'https://www.openbank.es/assets/static/pdf/Productos/Otros/Informacion_previa_contrato.pdf';
